import {
    IResult,
    IErrorResult,
    IITAPISResult,
} from '../../models/result-models';
import {
    LOAD_SHIPPING_METHODS_SUCCESS,
    LOAD_SHIPPING_METHODS_ERROR,
    UPDATE_SHIPPING_METHOD_SUCCESS,
    UPDATE_SHIPPING_METHOD_ERROR,
} from './shipping-actions';
import { IShippingMethods } from '../../models/shipping';

interface ShippingMethodsSuccess {
    type: 'LOAD_SHIPPING_METHODS_SUCCESS';
    payload: IResult<IShippingMethods[]>;
}

interface ShippingMethodsError {
    type: 'LOAD_SHIPPING_METHODS_ERROR';
    payload: IErrorResult;
}

interface UpdateShippingMethodSuccess {
    type: 'UPDATE_SHIPPING_METHOD_SUCCESS';
    payload: IResult<IITAPISResult>;
}

interface UpdateShippingMethodError {
    type: 'UPDATE_SHIPPING_METHOD_ERROR';
    payload: IErrorResult;
}

type LoadShippingKnownAction = ShippingMethodsSuccess | ShippingMethodsError;
type UpdateShippingKnownAction =
    | UpdateShippingMethodSuccess
    | UpdateShippingMethodError;
export const shippingMethodsReducer = (
    state: IResult<IShippingMethods[]> | null | undefined = null,
    action: LoadShippingKnownAction
) => {
    switch (action.type) {
        case LOAD_SHIPPING_METHODS_SUCCESS:
            return action.payload;
        case LOAD_SHIPPING_METHODS_ERROR:
            return {
                ok: false,
                message: action.payload.errorMessage,
            };
        default:
            return state;
    }
};

export const updateShippingMethodReducer = (
    state: IResult<IITAPISResult> | null | undefined = null,
    action: UpdateShippingKnownAction
) => {
    switch (action.type) {
        case UPDATE_SHIPPING_METHOD_SUCCESS:
            return action.payload;
        case UPDATE_SHIPPING_METHOD_ERROR:
            return {
                ok: false,
                message: action.payload.errorMessage,
            };
        default:
            return state;
    }
};
